/**
 * @ngdoc directive
 * @name directiveRaceReplay
 * @restrict A
 *
 * @description
 * Directive for race with fast result
 *
 * @element ANY
 */
export default function () {
    return {
        restrict: 'A', // Only attribute name can be used for directive definition
        scope: {},
        controller: 'directiveFastResultCtrl' // Executes before compile
    };
}



// WEBPACK FOOTER //
// ./src/js/directives/fastResult.js